
import { Injectable } from "@angular/core";

import { ActivatedRouteSnapshot, RouterStateSnapshot,

            Router } from "@angular/router";

import { AuthService } from "./auth.service";



@Injectable()

export class AuthGuard {



    constructor(private router: Router,

                private auth: AuthService) { }



    canActivate(route: ActivatedRouteSnapshot,

        state: RouterStateSnapshot): boolean {

            // 通过判断localstorage中有无id来激活路由守卫
            
            const user = sessionStorage.getItem('id');//获取

        if (user!=null) {

            console.log('路由守卫已激活')
            this.router.navigateByUrl("/home");

            return true;

        } 

        return false;

    }

}